import React, { useEffect, useState } from "react";
import API from "../../apiService";
import ALERT, { toast } from "../component/Alert";
import ModalAddType from "./ModalAddType";
import ModalShowImage from "./ModalShowImage";

const FormUploadImage = ({ history, detilPx }) => {
  const [type, setType] = useState(1);
  const [refTypes, setRefTypes] = useState([]);
  const [base64, setBase64] = useState(null);
  const [previewSrc, setPreviewSrc] = useState(null);
  const [list, setList] = useState([]);
  const [listByType, setListByType] = useState([]);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalShowImage, setShowModalShowImage] = useState(false);
  const [showImages, setShowImages] = useState([]);

  useEffect(() => {
    getRefTypes();
    loadList();
  }, []);

  const onReload = () => {
    history.push("/pelayanan");
  };

  const getRefTypes = async () => {
    const res = await API.get("registration/visit_image/types");
    if (res.code === 200) {
      setRefTypes(res.data);
    }
  };

  const loadList = async () => {
    const res = await API.get(
      "registration/visit_image/patient/read/" + detilPx.patients.id
    );
    if (res.code === 200) {
      setList(res.data);
      const types = res.data.map((v) => v.type);
      let unique = [
        ...new Map(types.map((item) => [item["id"], item])).values(),
      ];
      unique.forEach((v) => {
        v.list = res.data.filter((vv) => +vv.type_id === +v.id);
      });
      setListByType(unique);
    }
  };

  const PostData = async () => {
    if (!base64) {
      toast({ status: "error", text: "Pilih gambar dulu" });
      return;
    }

    var param = {
      type_id: type || (refTypes.length ? refTypes[0].id : ""),
      visit_id: detilPx.id,
      upload: base64,
    };

    let res = await API.post(`registration/visit_image/create`, param);

    if (res.code === 200) {
      if (res.code === 200) {
        ALERT("success", "Berhasil menyimpan data ");
        loadList();
        setBase64(null);
        setPreviewSrc(null);
        setType("");
      } else {
        ALERT("error", "gagal menyimpan data");
      }
    }
  };

  const saveNewType = async (v) => {
    const res = await API.post("registration/visit_image/types/create", {
      name: v,
    });
    if (res.code === 200) {
      loadList();
      toast({ status: "success", text: "Berhasil menambah tipe" });
    }
  };

  const handleShowImage = (filename) => {
    if (showImages.includes(filename)) {
      setShowImages(showImages.filter((item) => item !== filename));
    } else {
      setShowImages([...showImages, filename]);
    }
  };

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <div className="row align-items-center">
            <div className="col-8">
              <h4 className="h3 mb-0">Form Upload Gambar</h4>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className={"row"}>
            <div className={"col-7"}>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Tipe
                </label>
                <div className="col-md-7">
                  <div className="d-flex">
                    <select
                      className="form-control form-control-sm flex-grow-1"
                      id="example-text-input"
                      name="type"
                      defaultValue={type}
                      onChange={(e) => {
                        setType(e.target.value);
                      }}
                    >
                      {refTypes.map((v, k) => (
                        <option key={k} value={v.id}>
                          {v.name}
                        </option>
                      ))}
                    </select>
                    <button
                      className="btn btn-sm btn-success ml-2"
                      onClick={() => setShowModalAdd(true)}
                    >
                      <i className="fa fa-plus" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <UploadFile
                  setBase64={setBase64}
                  setPreviewSrc={setPreviewSrc}
                />
              </div>
            </div>
            <div className={"col-5"}>
              {previewSrc && <img src={previewSrc} style={{ width: "100%" }} />}
            </div>
            <div className={"col-12"}>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={PostData}
              >
                Simpan
              </button>
              <button className="btn btn-danger" onClick={onReload}>
                Tutup
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h4 className="h3 mb-0">Daftar Gambar</h4>
        </div>
        <div className="card-body" style={{ background: "#f5f5f5" }}>
          <div className={"row"}>
            {/*{*/}
            {/*    list.map((v, k) => (*/}
            {/*        <div className={'col-xl-3 col-md-4 col-sm-6'} key={k}>*/}
            {/*            <div className='card'>*/}
            {/*                <div className='card-body' style={{padding: 12}}>*/}
            {/*                    <img src={v.file_name} style={{width: '100%'}}/>*/}
            {/*                    <p className={'text-center'} style={{margin: '0px 8px 0px 0px', fontWeight: 'bold'}}>*/}
            {/*                        <strong>{v.type.name}</strong>*/}
            {/*                    </p>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    ))*/}
            {/*}*/}
            {listByType.map((t, tk) => (
              <div className={"col-12"} key={`l-${tk}`}>
                <div className={"row"}>
                  <h3 className={"ml-3"}>{t.name}</h3>
                </div>
                <div className={"row"}>
                  {t.list.map((v, k) => {
                    var last4 = v.file_name.substr(v.file_name.length - 4);
                    if (last4 == ".pdf") {
                      return (
                        <div className={"col-xl-3 col-md-4 col-sm-6"} key={k}>
                          <div className="card">
                            <div className="card-body" style={{ padding: 12 }}>
                              <iframe
                                alt={""}
                                src={v.file_name}
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  height: 250,
                                  objectFit: "cover",
                                }}
                              />
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => window.open(v.file_name)}
                              >
                                Preview
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className={"col-xl-3 col-md-4 col-sm-6"} key={k}>
                          <div className="card">
                            <div className="card-body" style={{ padding: 12 }}>
                              <div className="custom-control custom-checkbox mb-3">
                                <input
                                  id={`checkbox-${v.id}`}
                                  type="checkbox"
                                  className="custom-control-input"
                                  checked={showImages.includes(v.file_name)}
                                  onClick={() => handleShowImage(v.file_name)}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={`checkbox-${v.id}`}
                                >
                                  Pilih
                                </label>
                              </div>
                              <img
                                alt={""}
                                src={v.file_name}
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  height: 250,
                                  objectFit: "contain",
                                  borderWidth: 3,
                                  borderStyle: "solid",
                                  borderRadius: 5,
                                  borderColor: showImages.includes(v.file_name)
                                    ? "#5e72e4"
                                    : "#fff",
                                }}
                                onClick={() => handleShowImage(v.file_name)}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="card-footer">
          <button
            type="button"
            className="btn btn-block btn-success"
            disabled={!showImages.length}
            onClick={() => setShowModalShowImage(true)}
          >
            Tampilkan Gambar Terpilih
          </button>
        </div>
      </div>
      <ModalAddType
        show={showModalAdd}
        onHide={() => setShowModalAdd(false)}
        save={(v) => {
          if (v) {
            setShowModalAdd(false);
            saveNewType(v);
          }
        }}
      />
      <ModalShowImage
        show={showModalShowImage}
        onHide={() => setShowModalShowImage(false)}
        images={showImages}
      />
    </div>
  );
};

export const UploadFile = ({ setBase64, setPreviewSrc, ext }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [error, setError] = useState("");

  function validate(file) {
    const maxSize = 1000000;
    const extension = ext || "jpg,jpeg,png,pdf";

    let thisError;
    const extensions = extension.split(",");
    const arrFileName = file.name.split(".");
    const fileExtension = arrFileName[arrFileName.length - 1].toLowerCase();

    if (!extensions.includes(fileExtension)) {
      thisError = `extensi file harus ${extension}`;
      setError(thisError);
      return false;
    } else if (file.size > maxSize) {
      thisError = `ukuran file melebihi ${maxSize / 1024} KB`;
      setError(thisError);
      return false;
    } else {
      setError("");
      return true;
    }
  }

  function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  function resizeBase64Img(base64, newWidth, newHeight) {
    return new Promise((resolve, reject) => {
      let img_test = document.createElement("img");
      img_test.onload = function () {
        if (this.width < newWidth || this.height < newHeight) {
          resolve(base64);
        } else {
          let ratio = calculateAspectRatioFit(
            this.width,
            this.height,
            newWidth,
            newHeight
          );
          let canvas = document.createElement("canvas");
          canvas.width = ratio.width;
          canvas.height = ratio.height;

          let context = canvas.getContext("2d");
          context.drawImage(img_test, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL());
        }
      };
      img_test.src = base64;
    });
  }

  const preview = (files) => {
    if (files && files[0]) {
      const reader = new FileReader();
      reader.onload = function (e) {
        resizeBase64Img(e.target.result, 800, 800).then((r) => {
          setPreviewSrc(r);
          // $('#new-image-preview').attr('src', r);
          // uploadImage(r);
          // $('#btn-plus').hide();
          // $('#loader').show();
        });
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const handleChange = async (e) => {
    preview(e.target.files);
    if (!validate(e.target.files[0])) return "";
    setIsLoading(true);
    const fileBase64 = await toBase64(e.target.files[0]);
    setBase64(fileBase64);
  };

  return (
    <>
      <label
        htmlFor="example-text-input"
        className="col-md-5 col-form-label col-form-label-sm"
      >
        <span>upload file</span>
        <span className="text-success pl-2">
          {isCompleted && <i className="fas fa-check-circle fa-1x" />}
        </span>
      </label>
      <br />
      <input
        className="form-control form-control-sm col-md-4"
        type="file"
        onChange={(e) => handleChange(e)}
      />
      <br />
      {error ? <span className="text-danger">{error}</span> : ""}
    </>
  );
};

const toBase64 = async (file) => {
  if (await file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
};

export default FormUploadImage;
